<city-tax-app-header
    [heading]="'Common.heading' | translate"
    [src]="'assets/logo/logo.png'"
    [subHeading]="'Common.sub-individual-heading' | translate"
>
</city-tax-app-header>

<div class="tax-payment-section">
  <div class="container pt-4 mb-3">
    <div class="row n-shadow">

      <!-- Landing Individual Component -->
      <div *ngIf="hasIndividual" [ngClass]="{'col-12 col-md-12': !hasBusiness, 'col-12 col-md-6': hasBusiness}" class="p-3 bg-white">
        <city-tax-landing-individual (lookupEvent)="onLookup()" [config$]="config$"></city-tax-landing-individual>
      </div>

      <!-- Landing Business Component -->
      <div *ngIf="hasBusiness" [ngClass]="{'col-12 col-md-12': !hasIndividual, 'col-md-6': hasIndividual}" class="p-3 bg-primary">
        <city-tax-landing-business [config$]="config$"></city-tax-landing-business>
      </div>

    </div>
  </div>
  <div class="container-fluid px-0 ">
    <div class="container ">
      <city-tax-landing-footer [config$]="config$"></city-tax-landing-footer>
    </div>
  </div>
</div>

